var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"control-tab",class:{ 'is-active': _vm.isActive },attrs:{"type":"button"},on:{"click":_vm.changeTab}},[_c('span',[_vm._v(_vm._s(_vm.tabName))])])}
var staticRenderFns = []

export { render, staticRenderFns }